import style from './statusList.module.css';

import { observer } from 'mobx-react-lite';
import Iteration from './Iteration';
import { SchemeNodeTypes } from 'consts/scheme.consts';
import { productionStore } from 'store/mobx/production.store';

const StatusList = observer(() => {
  const { listIteration } = productionStore;

  return (
    <div className={style.container}>
      {listIteration.map((item) => {
        const children = item?.children
          ?.filter((item) => item.type !== SchemeNodeTypes.qualityControl)
          ?.reduce((acc, parent) => {
            if (parent.objects?.length > 0) return acc.concat(parent.objects);
            else
              return acc.concat([
                {
                  id: Math.floor(Math.random() * (1999999 - 1000 + 1)) + 1000,
                  type: 'storage',
                  name: 'Хранилище',
                },
              ]);
          }, [])
          ?.filter((obj, index, self) => index === self.findIndex((o) => o.id === obj.id));

        return (
          <Iteration
            key={item.id}
            item={item}
            status={item.status}
            objects={item.objects}
            childrenArray={children}
          />
        );
      })}
    </div>
  );
});

export default StatusList;
